import React, { Component } from 'react';
import { Icon, Button, Grid, Popup} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import PropTypes from "prop-types";
import {
    DateInput
} from 'semantic-ui-calendar-react';

export default class ReportButtonMonthly extends Component {

    state = {
        fromDate: this.convertDate(this.props.fromDate),
        toDate: this.convertDate(this.props.toDate),
        fixedDates: this.props.fixedDates, 
    }

    convertDate(date) {
       
        // Assuming date is initially in DD/MM/YYYY format, convert to MMM/YYYY
        const [day, month, year] = date.split('/');
        const dateObject = new Date(year, month - 1, day);
        return dateObject.toLocaleString('default', { month: 'short', year: 'numeric' });
    }

    handleDateChange(name, value) {
        this.setState({
            [name]: value
        });

       
        this.props.returnDate(this.props.reportType, name, value);

    };

    render() {
        return (
            
            <Popup  content={this.props.popupText} disabled={this.props.popupHidden} position='top center' inverted trigger={
                <div className='report'>
                    <Grid textAlign='center'>
                        <Grid.Row>
                        <Icon name={this.props.iconName} size='huge' /> 
                        </Grid.Row>

                        <Grid.Row>
                            <h3>{this.props.text}</h3>
                        </Grid.Row>

                        <Grid.Row>
                            <label className="dateLabel" >Month (from)
                                <DateInput disabled={this.state.fixedDates}
                                                    popupPosition="top center"
                                                    dateFormat="MMM YYYY"
                                                    animation='none'
                                                    name="fromDate"
                                                    value={this.state.fromDate}
                                                    placeholder='From Date'
                                                    closable='true'
                                                    onChange={(a, { name, value }) => this.handleDateChange(name, value)}
                                                />
                                                </label>
                        </Grid.Row>
                        <Grid.Row>
                            <label >Month (to)
                                <DateInput disabled={this.state.fixedDates}
                                                    popupPosition="top center"
                                                    dateFormat="MMM YYYY"
                                                    animation='none'
                                                    name="toDate"
                                                    value={this.state.toDate}
                                                    placeholder='To Date'
                                                    closable='true'
                                                    onChange={(a, { name, value }) => this.handleDateChange(name, value)}
                                                />
                                </label>
                        </Grid.Row>
                        <Grid.Row>
                            <Button onClick={this.props.onclickmethod} inverted>Generate</Button>
                        </Grid.Row>
                    </Grid>
                </div>
            }/>
        );
    }
}

ReportButtonMonthly.propTypes = {
    color: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    querystring: PropTypes.string,
    onclickmethod : PropTypes.object,
    iconName: PropTypes.string.isRequired
};